import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { LanguageService } from '../serviceLayer/language.service';
import { Router } from '@angular/router';

@Directive({
  standalone: false,
  selector: '[routerLink]',
  host: {
    '[routerLink]': 'getLanguageAwareRoute()'
  }
})
export class LanguageRouterLinkDirective implements OnInit {
  @Input() routerLink: any;

  constructor(
    private languageService: LanguageService,
    private router: Router
  ) {}

  ngOnInit() {}

  getLanguageAwareRoute(): any {
    if (typeof this.routerLink === 'string') {
      return this.languageService.getLanguageAwareUrl(this.routerLink);
    } else if (Array.isArray(this.routerLink)) {
      // Handle array-based routes like ['/vehicle', {id: 123}]
      const firstSegment = this.routerLink[0];
      if (typeof firstSegment === 'string') {
        const awareSegment = this.languageService.getLanguageAwareUrl(firstSegment);
        // If it's just the first segment, return as is
        if (this.routerLink.length === 1) {
          return awareSegment;
        }
        // For complex routes, reconstruct
        return [awareSegment, ...this.routerLink.slice(1)];
      }
    }
    return this.routerLink;
  }
}

